import React from 'react';
import { Breadcrumb as BSBreadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const Breadcrumb = ({ items = [] }) => {
  return (
    <BSBreadcrumb className="bg-light px-3 py-2 rounded mb-3">
      <BSBreadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
        <FaHome className="me-1" />
        Home
      </BSBreadcrumb.Item>
      {items.map((item, index) => (
        <BSBreadcrumb.Item
          key={index}
          linkAs={item.link ? Link : 'span'}
          linkProps={item.link ? { to: item.link } : {}}
          active={index === items.length - 1}
        >
          {item.label}
        </BSBreadcrumb.Item>
      ))}
    </BSBreadcrumb>
  );
};

export default Breadcrumb;
